


































































import { Component, Vue } from 'vue-property-decorator';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { Getter, Action } from 'vuex-class';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import DataTable from '@/shared/components/dataTable/DataTable.vue';
import FriendlyString from '@/shared/components/FriendlyString.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import CreateAttribute from '@/features/settings/components/CreateAttribute.vue';
import { ContactAttributeType } from '@/messaging/models/contactAttributeType';
import UpdateAttribute from '@/features/settings/components/UpdateAttribute.vue';
import DataTableColumn from '@/shared/components/dataTable/dataTableColumn';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import { ARCHIVE_CONTACT_ATTRIBUTE } from '@/store/attributes/actionTypes';
import Toast from '@/shared/services/toast';

@Component({
	components: {
		DataTable,
		FriendlyString,
		CreateAttribute,
		UpdateAttribute,
		ConfirmationModal,
		DropDownMenu,
		DeleteIcon
	}
})
export default class ContactAttributes extends Vue {
	@Action(ARCHIVE_CONTACT_ATTRIBUTE) public updateAttribute: (attributeId: string) => Promise<any>;
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public allContactAttributes!: ContactAttributeViewModel[];

	public isLoading: boolean = false;
	public showCreateAttributeModal: boolean = false;
	public showUpdateAttributeModal: boolean = false;
	public showArchiveAttributeModal: boolean = false;
	public selectedAttribute: ContactAttributeViewModel = {} as ContactAttributeViewModel;

	public openCreateAttributeModal() {
		this.showCreateAttributeModal = true;
	}

	public openEditAttribute(attribute: ContactAttributeViewModel) {
		this.selectedAttribute = attribute;
		this.showUpdateAttributeModal = true;
	}

	public closeAttributeModal() {
		this.showCreateAttributeModal = false;
		this.showUpdateAttributeModal = false;
	}

	public getTypeDisplay(typeValue: string) {
		return Object.keys(ContactAttributeType).filter(x => (ContactAttributeType as any)[x] === typeValue)[0];
	}

	public showArchiveModal(attribute: ContactAttributeViewModel) {
		this.selectedAttribute = attribute;
		this.showArchiveAttributeModal = true;
	}

	public async archiveAttribute() {
		this.showArchiveAttributeModal = false;
		try {
			await this.updateAttribute(this.selectedAttribute.id);
			Toast.showSuccess(`Successfully archived attribute: ${this.selectedAttribute.name}`);
		} catch (err) {
			Toast.showError(err.message);
		}
	}

	public getArchiveConfirmationMessage() {
		return `Are you sure you want to archive attribute <b>${HtmlFormatter.escapeHtmlCharacters(this.selectedAttribute.name)}</b>?`;
	}

	private getColumns(): DataTableColumn[] {
		return [
			{
				display: 'Name',
				name: 'name',
				clickable: (row: ContactAttributeViewModel) => !row.system && !row.archived
			},
			{
				display: 'Type',
				name: 'type'
			},
			{
				display: 'Description',
				name: 'description',
				wrappable: true
			}
		];
	}
}
